import { User } from 'hooks/useUsers'

const isMerchant = (user: User): boolean => user.userType === 'merchant'
const isSuperAdmin = (user: User): boolean => user.role === 'SUPER_ADMIN'
const isAdmin = (user: User): boolean => user.role === 'ADMIN'
const isAnyAdmin = (user: User): boolean => isAdmin(user) || isSuperAdmin(user)

export { isMerchant, isSuperAdmin, isAdmin, isAnyAdmin }